import { goalsEn } from "@domains/goals/client/i18n/en.ts";
import { goodVibesEn, goodVibeCardEn, goodVibeDetailDialogEn } from "@domains/good-vibes/client/i18n/en.ts";

export const en = {
    ...goalsEn,
    ...goodVibesEn,
    Errors: {
        retry: "Try again",
        retrying: "Retrying",
        reassurance: "Please try again later.",
        refreshBanner: "Couldn't refresh — showing the last results."
    },
    CreateMenu: {
        newGoal: "New goal"
    },
    NewGoalPage: {
        creating: "Creating your goal",
        error: "We couldn't create the goal. Please try again."
    },
    Navigation: {
        people: {
            label: "People",
            description: "Directory, departments, locations",
            main: {
                label: "People",
                people: { label: "People", description: "Directory, departments, locations" },
                departments: { label: "Departments" },
                locations: { label: "Locations" },
                company: { label: "Company" },
                "org-chart": { label: "Org chart" }
            }
        },
        "people-department": { label: "Department" },
        "people-location": { label: "Location" },
        "people-meeting": { label: "Meeting" },
        "people-review": { label: "Review" },
        "people-progression-reviews": { label: "Reviews", description: "Your reviews in a table view" },
        "people-review-write": { label: "Write review" },
        "people-review-share": { label: "Share review" },
        "people-goal": { label: "Goal" },
        "people-goal-edit": { label: "Edit goal" },
        "people-progression-goals": { label: "Goals", description: "Your goals in a table view" },
        "people-engagement-feedback": { label: "Your feedback", description: "All the feedback you've sent" },
        "goal-new": { label: "New goal" },
        "people-profile": {
            label: "Profile",
            main: {
                label: "Profile",
                overview: { label: "Overview" },
                goals: { label: "Goals" },
                reviews: { label: "Reviews" },
                timeline: { label: "Timeline" },
                "good-vibes": { label: "Good Vibes" },
                meetings: { label: "Meetings" },
                engagement: { label: "Engagement" },
                progression: { label: "Progression" }
            }
        }
    },
    PeopleListPage: {
        error: "We couldn't load the directory right now.",
        noResults: "No employees were found",
        noData: "No employees yet.",
        noResultsHint: "Try adjusting your filters.",
        totalCount_one: "{{count}} Employee",
        totalCount_other: "{{count}} Employees",
        viewToggle: {
            groupLabel: "View mode",
            tableView: "List view",
            cardView: "Card view"
        },
        liveRegion: {
            loading: "Loading employees",
            sortedAscending: "Table sorted by {{column}}, ascending",
            sortedDescending: "Table sorted by {{column}}, descending",
            loadingMoreAnnouncement: "Loading more employees",
            loadedMore_one: "Loaded {{count}} more employee",
            loadedMore_other: "Loaded {{count}} more employees",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    PeopleListToolbar: {
        searchPlaceholder: "Search employees",
        searchAriaLabel: "Search employees",
        resetFilters: "Reset filters",
        filters: {
            department: "Department",
            location: "Location",
            departmentAriaLabel: "Filter by department",
            locationAriaLabel: "Filter by location",
            clearFilter: "Clear filter"
        }
    },
    PeopleTableView: {
        ariaLabel: "Employees table",
        columns: {
            name: "Name",
            title: "Title",
            department: "Department",
            location: "Location"
        }
    },
    PeopleCardsView: {
        ariaLabel: "Employees"
    },
    PeopleYouBadge: {
        you: "You"
    },
    MemberAvatarStack: {
        memberCount_one: "{{count}} person",
        memberCount_other: "{{count}} people",
        overflowCount: "+{{count}}",
        membersAriaLabel_one: "{{count}} member",
        membersAriaLabel_other: "{{count}} members"
    },
    PeopleDepartmentsListPage: {
        error: "We couldn't load departments right now.",
        noResults: "No departments were found",
        noData: "No departments yet.",
        noResultsHint: "Try adjusting your filters.",
        totalCount_one: "{{count}} Department",
        totalCount_other: "{{count}} Departments",
        liveRegion: {
            loading: "Loading departments",
            sortedAscending: "Table sorted by {{column}}, ascending",
            sortedDescending: "Table sorted by {{column}}, descending",
            loadingMoreAnnouncement: "Loading more departments",
            loadedMore_one: "Loaded {{count}} more department",
            loadedMore_other: "Loaded {{count}} more departments",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    PeopleDepartmentsToolbar: {
        searchPlaceholder: "Search departments",
        searchAriaLabel: "Search departments",
        resetFilters: "Reset filters"
    },
    PeopleDepartmentsTable: {
        ariaLabel: "Departments table",
        columns: {
            name: "Name",
            members: "Members"
        }
    },
    PeopleLocationsListPage: {
        error: "We couldn't load locations right now.",
        noResults: "No locations were found",
        noData: "No locations yet.",
        noResultsHint: "Try adjusting your filters.",
        totalCount_one: "{{count}} Location",
        totalCount_other: "{{count}} Locations",
        liveRegion: {
            loading: "Loading locations",
            sortedAscending: "Table sorted by {{column}}, ascending",
            sortedDescending: "Table sorted by {{column}}, descending",
            loadingMoreAnnouncement: "Loading more locations",
            loadedMore_one: "Loaded {{count}} more location",
            loadedMore_other: "Loaded {{count}} more locations",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    PeopleLocationsToolbar: {
        searchPlaceholder: "Search locations",
        searchAriaLabel: "Search locations",
        resetFilters: "Reset filters"
    },
    PeopleLocationsTable: {
        ariaLabel: "Locations table",
        columns: {
            name: "Name",
            members: "Members"
        }
    },
    DepartmentDetailPage: {
        error: "We couldn't load the department members right now.",
        noData: "No employees in this department.",
        noSearchResults: "No employees match your search",
        liveRegion: {
            loading: "Loading employees",
            loadingMoreAnnouncement: "Loading more employees",
            loadedMore_one: "Loaded {{count}} more employee",
            loadedMore_other: "Loaded {{count}} more employees",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    DepartmentDetailHeader: {
        breadcrumb: {
            departments: "Departments",
            ariaLabel: "Breadcrumb"
        }
    },
    DepartmentMembersToolbar: {
        searchPlaceholder: "Search employees",
        searchAriaLabel: "Search employees",
        totalCount_one: "{{count}} EMPLOYEE",
        totalCount_other: "{{count}} EMPLOYEES"
    },
    DepartmentMembersTable: {
        ariaLabel: "Department members",
        columns: {
            name: "NAME",
            title: "TITLE",
            location: "LOCATION"
        }
    },
    DepartmentNotFound: {
        heading: "Department not found",
        body: "We couldn't find that department. It may have been moved or removed.",
        backToDirectory: "Back to departments"
    },
    ProfileMeetingsPage: {
        error: "We couldn't load your meetings right now.",
        noData: "No meetings yet. They'll show up here once they're on your calendar.",
        noDataForPerson: "No meetings with this person yet. They'll show up here once they're on your calendar.",
        noResults: "No meetings found",
        noResultsHint: "Try a different search term or clear your filters.",
        clearFilters: "Clear filters",
        totalCount_one: "{{count}} Meeting",
        totalCount_other: "{{count}} Meetings",
        liveRegion: {
            sortChanged: "Sorted by date {{direction}}",
            ascending: "ascending",
            descending: "descending",
            loading: "Loading meetings",
            loadingMoreAnnouncement: "Loading more meetings",
            loadedMore_one: "Loaded {{count}} more meeting",
            loadedMore_other: "Loaded {{count}} more meetings",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    MeetingDetailPage: {
        breadcrumb: {
            ariaLabel: "Breadcrumb",
            people: "People",
            meetings: "Meetings",
            deletedMember: "Deleted member"
        },
        liveRegion: {
            loading: "Loading the meeting"
        },
        context: {
            open: "Show context",
            close: "Hide context"
        }
    },
    LocationDetailPage: {
        error: "We couldn't load the location members right now.",
        noData: "No employees in this location.",
        noSearchResults: "No employees match your search",
        liveRegion: {
            loading: "Loading employees",
            loadingMoreAnnouncement: "Loading more employees",
            loadedMore_one: "Loaded {{count}} more employee",
            loadedMore_other: "Loaded {{count}} more employees",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    LocationDetailHeader: {
        breadcrumb: {
            locations: "Locations",
            ariaLabel: "Breadcrumb"
        }
    },
    LocationMembersToolbar: {
        searchPlaceholder: "Search employees",
        searchAriaLabel: "Search employees",
        totalCount_one: "{{count}} employee",
        totalCount_other: "{{count}} employees"
    },
    LocationMembersTable: {
        ariaLabel: "Location members",
        columns: {
            name: "Name",
            title: "Title",
            department: "Department"
        }
    },
    LocationNotFound: {
        heading: "Location not found",
        body: "We couldn't find that location. It may have been moved or removed.",
        backToDirectory: "Back to locations"
    },
    PeopleCompanyPage: {
        missionLabel: "Mission",
        valuesLabel: "Values",
        editButton: "Edit",
        liveRegion: {
            loading: "Loading company profile"
        },
        adminEmpty: {
            missionPlaceholder: "What you exist to do.",
            valuesPlaceholder: "The principles your team works by."
        }
    },
    PeopleOrgChartPage: {
        title: "Org chart",
        subtitle: "Placeholder — Org chart tab content will live here."
    },
    CompanyOrgChartWidget: {
        label: "Org chart",
        viewInOrgChart: "View in org chart",
        treeLabel: "Company org chart",
        unknownMember: "Unknown member",
        youBadge: "You",
        youSuffix: "{{name}} (you)",
        viewMore: "View {{count}} more in the org chart",
        tooltipMore: "and {{count}} more",
        liveRegion: {
            loading: "Loading the org chart"
        },
        empty: {
            title: "No one's in the org chart yet."
        },
        error: {
            title: "Couldn't load the org chart.",
            description: "Please try again later.",
            retry: "Try again",
            retrying: "Retrying"
        },
        orgChartModal: {
            eyebrow: "Heads up",
            title: "One quick detour",
            body: "The full org chart isn't available in the new app yet. We'll take you to Pingboard to see it.",
            cancel: "Cancel",
            continue: "Continue in Pingboard"
        }
    },
    ProfileTabsHeading: {
        liveRegion: {
            loading: "Loading profile"
        },
        breadcrumb: {
            ariaLabel: "Breadcrumb",
            people: "People"
        }
    },
    ProfileOverviewPage: {
        empty: "There's nothing to show on this profile yet.",
        loadError: "This profile couldn't be loaded right now. Refresh to try again.",
        liveRegion: {
            loading: "Loading profile"
        }
    },
    ProfileHeader: {
        newHireBadge: "New hire",
        reportsTo: "Reports to",
        joined: "Joined {{date}}"
    },
    ProfileGoalsPage: {
        create: {
            newGoal: "New goal",
            error: "Error creating goal"
        },
        liveRegion: {
            loading: "Loading goals",
            sortChanged: "Goals sorted by {{option}}"
        },
        empty: {
            headline: "No goals for {{firstName}} this quarter.",
            subtext: "Goals set here appear in reviews and in 1:1 agendas.",
            noMatch: {
                headline: "No goals match these filters for {{firstName}}.",
                subtext: "Try adjusting or resetting your filters."
            }
        },
        error: "We couldn't load goals right now."
    },
    ProfileGoalsToolbar: {
        searchPlaceholder: "Search goals",
        searchAriaLabel: "Search goals",
        relationship: {
            ariaLabel: "Filter by relationship",
            clearAriaLabel: "Clear relationship filter",
            owner: "Owner",
            contributor: "Contributor",
            all: "Owner or contributor"
        },
        status: {
            ariaLabel: "Filter by status",
            clearAriaLabel: "Clear status filter",
            all: "All statuses",
            onTrack: "On track",
            atRisk: "At risk",
            offTrack: "Off track",
            noStatus: "No status"
        },
        publicationState: {
            label: "State",
            ariaLabel: "Filter by state",
            trigger: "State: {{states}}",
            separator: ", ",
            active: "Active",
            draft: "Draft",
            archived: "Archived",
            reset: "Reset to default"
        },
        goalType: {
            ariaLabel: "Filter by type",
            clearAriaLabel: "Clear type filter",
            all: "All types",
            organization: "Organization",
            team: "Team",
            individual: "Individual"
        },
        resetFilters: "Reset filters",
        sort: {
            ariaLabel: "Sort goals by",
            label: "Sort",
            options: {
                lastUpdatedAt: "Recently updated",
                progress: "Progress",
                dueDate: "Due date",
                title: "Title"
            }
        },
        goalCount_one: "{{count}} Goal",
        goalCount_other: "{{count}} Goals"
    },
    GoalActions: {
        ariaLabel: "Actions for {{title}}",
        edit: "Edit goal",
        updateProgress: "Update progress",
        duplicate: "Duplicate goal",
        archive: "Archive goal",
        unarchive: "Unarchive goal",
        delete: "Delete goal",
        cancel: "Cancel",
        untitled: "Untitled goal",
        archiveDialog: {
            title: "Archive goal",
            description: "{{title}} moves out of the active goals. You can unarchive it at any time."
        },
        unarchiveDialog: {
            title: "Unarchive goal",
            description: "{{title}} moves back into the active goals."
        },
        deleteDialog: {
            title: "Delete goal?",
            description: "{{title}} will be deleted. This action cannot be undone."
        },
        toast: {
            duplicated: "Goal duplicated successfully",
            duplicateError: "Error duplicating goal",
            archived: "Goal archived successfully",
            archiveError: "Error archiving goal",
            unarchived: "Goal unarchived successfully",
            unarchiveError: "Error unarchiving goal",
            deleted: "Goal deleted successfully",
            deleteError: "Error deleting goal"
        }
    },
    GoalCard: {
        deletedMember: "Deleted member",
        untitled: "Untitled goal",
        draft: "Draft",
        archived: "Archived",
        type: {
            personal: "Individual goal",
            team: "Team goal",
            organization: "Organization goal"
        },
        status: {
            onTrack: "On track",
            atRisk: "At risk",
            offTrack: "Off track",
            noStatus: "No status"
        },
        alignedTo: "Aligned to",
        progressAriaLabel: "Goal progress",
        progressPercent: "{{value}}%",
        dueDate: "Due {{date}}",
        overdue: "Overdue",
        latestUpdateLabel: "Latest update",
        updateMeta: "{{author}} · {{time}}",
        noUpdates: "No updates posted yet.",
        relativeTime: {
            today: "Today",
            days_one: "{{count}} day ago",
            days_other: "{{count}} days ago",
            weeks_one: "{{count}} week ago",
            weeks_other: "{{count}} weeks ago"
        }
    },
    EngagementFeedbackListPage: {
        pageTitle: "Your feedback",
        breadcrumb: {
            ariaLabel: "Your feedback breadcrumb",
            here: "Your feedback"
        }
    },
    ProfileReviewsListPage: {
        title: "Your reviews",
        breadcrumb: {
            ariaLabel: "Breadcrumb",
            reviews: "Reviews"
        },
        viewAs: {
            ariaLabel: "View reviews as",
            clearAriaLabel: "Clear scope filter",
            reviewee: "As the reviewee",
            reviewer: "As the reviewer"
        },
        error: "We couldn't load reviews right now.",
        accessDenied: {
            headline: "You don't have access to these reviews",
            subtext: "These reviews are private to the reviewee and their reviewers."
        },
        empty: {
            heading: "No reviews yet",
            hint: "Reviews shared with you will appear here once a review cycle is underway."
        },
        noResults: "No reviews match your filters",
        noResultsHint: "Try adjusting your filters or search.",
        totalCount_one: "{{count}} Review",
        totalCount_other: "{{count}} Reviews",
        liveRegion: {
            loading: "Loading reviews",
            loadingMoreAnnouncement: "Loading more reviews",
            loadedMore_one: "Loaded {{count}} more review",
            loadedMore_other: "Loaded {{count}} more reviews",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    ProgressionGoalsListPage: {
        pageTitle: "Your goals",
        liveRegion: {
            loading: "Loading goals",
            sortChanged: "Sorted by {{column}}"
        },
        breadcrumb: {
            ariaLabel: "Progression Goals breadcrumb",
            here: "Goals"
        },
        empty: {
            headline: "You haven't set any goals yet.",
            subtext: "Goals set here appear in reviews and in 1:1 agendas.",
            noMatch: {
                headline: "No goals match these filters.",
                subtext: "Try adjusting or resetting your filters."
            }
        },
        totalCount_one: "{{count}} Goal",
        totalCount_other: "{{count}} Goals",
        error: "We couldn't load goals right now."
    },
    ProgressionGoalsTable: {
        ariaLabel: "My goals",
        untitledGoal: "Untitled goal",
        columns: {
            goal: "Goal",
            due: "Due",
            status: "Status",
            progress: "Progress",
            updated: "Updated",
            actions: "Actions"
        }
    },
    ProgressionGoalRow: {
        deletedMember: "Deleted member",
        draft: "Draft",
        archived: "Archived",
        untitled: "Untitled goal",
        status: {
            onTrack: "On track",
            atRisk: "At risk",
            offTrack: "Off track",
            noStatus: "No status"
        },
        type: {
            organization: "Organization",
            team: "Team",
            personal: "Individual"
        },
        noDate: "No date",
        overdue: "Overdue",
        progressAriaLabel: "Goal progress",
        progressPercent: "{{value}}%",
        updated: {
            never: "Never",
            today: "Today",
            days: "{{count}}d ago",
            weeks: "{{count}}w ago"
        }
    },
    ProfileReviewsPage: {
        error: "We couldn't load reviews right now.",
        accessDenied: {
            headline: "You don't have access to these reviews",
            subtext: "These reviews are private to the reviewee and their reviewers."
        },
        empty: {
            heading: "No reviews yet",
            hint: "Performance reviews for this person will appear here once a review cycle is underway."
        },
        noResults: "No reviews were found",
        noResultsHint: "Try adjusting your filters.",
        totalCount_one: "{{count}} Review",
        totalCount_other: "{{count}} Reviews",
        liveRegion: {
            loading: "Loading reviews",
            loadingMoreAnnouncement: "Loading more reviews",
            loadedMore_one: "Loaded {{count}} more review",
            loadedMore_other: "Loaded {{count}} more reviews",
            results_one: "{{count}} result",
            results_other: "{{count}} results"
        }
    },
    ReviewsToolbar: {
        searchPlaceholder: "Search reviews",
        searchAriaLabel: "Search reviews",
        scope: {
            ariaLabel: "Time scope",
            latest: "Latest review",
            past90: "Past 90 days",
            pastYear: "Past year",
            allTime: "All time"
        },
        cycleStatus: {
            ariaLabel: "Cycle status",
            all: "From all cycles",
            active: "From active cycles",
            locked: "From locked cycles"
        },
        sharing: {
            ariaLabel: "Sharing",
            all: "All sharing",
            notShared: "Not shared",
            shared: "Shared",
            acknowledged: "Acknowledged"
        },
        clearScope: "Clear time scope filter",
        clearCycleStatus: "Clear cycle status filter",
        clearSharing: "Clear sharing filter",
        resetFilters: "Reset filters"
    },
    ReviewsTable: {
        ariaLabel: "Reviews",
        columns: {
            review: "Review",
            score: "Score",
            period: "Period",
            types: "Types",
            sharing: "Sharing"
        },
        expandRow: "Show reviewers for {{reviewee}}",
        collapseRow: "Hide reviewers for {{reviewee}}",
        drawerRow: "Reviewers for {{reviewee}}",
        noReviewsGroup: "No reviews ({{count}})"
    },
    ReviewRow: {
        noReviewsYet: "No reviews yet",
        mobileLabels: {
            score: "Review score",
            period: "Evaluation period",
            types: "Review types",
            sharing: "Sharing"
        },
        types: {
            self: "Self",
            manager: "Manager",
            peer: "Peer",
            upward: "Upward"
        },
        sharing: {
            notShared: "Not shared",
            shared: "Shared",
            acknowledged: "Acknowledged"
        }
    },
    ReviewLotDrawer: {
        liveRegion: {
            loading: "Loading reviewers"
        },
        error: "Couldn't load reviewers.",
        retry: "Retry",
        empty: "No reviewers for this review."
    },
    LotReviewerRow: {
        roles: {
            self: "Self",
            manager: "Manager",
            peer: "Peer",
            upward: "Upward"
        },
        status: {
            notStarted: "Not started",
            inProgress: "In progress",
            submitted: "Submitted",
            overdue: "Overdue"
        },
        submittedOn: "on {{date}}",
        dueOn: "Due {{date}}",
        anonymous: {
            peer: "Anonymous peer",
            upward: "Anonymous upward reviewer",
            reviewer: "Anonymous reviewer"
        },
        noDirectManager: "No Direct Manager",
        deletedMember: "Deleted member"
    },
    ReviewWritePage: {
        untitledCycle: "Review",
        breadcrumb: { ariaLabel: "Breadcrumb", people: "People", progression: "Progression", reviews: "Reviews", reviewType: { manager: "Manager review", self: "Self review", peer: "Peer review", upward: "Upward review" } },
        cycleDescription: { expand: "Show more", collapse: "Show less" },
        perspectives: { yours: "Your review", manager: "Manager", self: "Self", peer: "Peers", upward: "Upward" },
        assistant: {
            welcomeMessage: "Hi {{reviewerName}}, let's get going on {{revieweeName}}'s review",
            welcomeMessageSelf: "Hi {{reviewerName}}, let's get going on your review",
            subtext: {
                role: "currently {{jobTitle}}",
                team: "{{name}} is on the {{department}} team",
                teamTenure_one: "{{name}} has been at {{company}} for {{count}} year, on the {{department}} team",
                teamTenure_other: "{{name}} has been at {{company}} for {{count}} years, on the {{department}} team",
                teamTenureLessThanYear: "{{name}} has been at {{company}} for less than a year, on the {{department}} team",
                tenure_one: "{{name}} has been at {{company}} for {{count}} year",
                tenure_other: "{{name}} has been at {{company}} for {{count}} years",
                tenureLessThanYear: "{{name}} has been at {{company}} for less than a year",
                selfTenure_one: "{{count}} year at {{company}}",
                selfTenure_other: "{{count}} years at {{company}}",
                selfTenureLessThanYear: "Less than a year at {{company}}"
            },
            inputPlaceholder: "Ask me to prepare or draft an answer…",
            initialSuggestion: "Help me prepare the review"
        },
        loading: "Loading review",
        progress: "{{answered}} of {{total}} answered",
        autoSave: {
            saving: "Saving…",
            saved: "Saved",
            error: "Couldn't save — retrying"
        },
        submit: "Submit review",
        submitBlocked: "Answer every required question to submit",
        submitSucceeded: "Review submitted",
        submitFailed: "Couldn't submit the review",
        submitBlockedUnsaved: "We couldn't save your latest answer, so the review wasn't submitted. We're still retrying — try again in a moment.",
        cancel: "Cancel",
        update: "Update review",
        updateSucceeded: "Review updated",
        unsavedChanges: "You have unsaved changes",
        saveFailed: "We couldn't save your changes. They're still here — try again.",
        assistantUpdated: "Workleap AI updated this review",
        discard: {
            heading: "Leave without saving?",
            body: "Your changes to this review haven't been saved. Leaving now discards them.",
            keepEditing: "Keep editing",
            discard: "Discard changes"
        },
        showAnswersInline: "Show answers inline",
        question: {
            optional: "Optional",
            textPlaceholder: "Write your answer…",
            ratingLabel: "Rating",
            choiceLabel: "Choices",
            unlabeledValue: "Level {{value}}",
            inlineSelectedBy: "Also selected by {{names}}",
            notInYourReview: "Not part of your review"
        },
        context: {
            title: "Context",
            open: "Show context",
            close: "Hide context",
            workleapGroup: "Workleap",
            externalGroup: "External",
            emptyGroup: "Nothing here yet",
            progress: "{{value}}%",
            showing: "Showing {{shown}} of {{total}}",
            viewAll: "View all ({{count}})",
            back: "Back",
            sourcesCount: "{{count}} sources",
            sourceFrom: "from {{source}}",
            sourceTypes: {
                Role: "Role",
                Goals: "Goals",
                CurrentReviews: "Current reviews",
                PastReviews: "Past reviews",
                Recognition: "Good Vibes",
                Agendas: "1on1s",
                Engagement: "Engagement",
                Feedback: "Feedback"
            },
            visibility: {
                public: "Public",
                direct: "Direct"
            }
        }
    },
    ReviewDetailsPage: {
        breadcrumb: {
            ariaLabel: "Breadcrumb",
            people: "People",
            progression: "Progression",
            reviews: "Reviews"
        },
        liveRegion: {
            loading: "Loading review"
        },
        error: "We couldn't load this review right now.",
        accessDenied: {
            headline: "You don't have access to this review",
            subtext: "This review is private to the reviewee and their reviewers."
        },
        empty: {
            heading: "This review hasn't started yet",
            hint: "Answers will appear here once the review is underway."
        }
    },
    ReviewDetailHeader: {
        untitledCycle: "Performance review",
        covers: "Covers {{period}}",
        visibility: {
            reportingLine: "Visible to {{name}}'s direct manager and higher-ups"
        },
        acknowledgedBy: "Acknowledged by {{name}} · {{date}}",
        sharedBy: "Shared by {{name}} · {{date}}"
    },
    ReviewSharePreview: {
        pageTitle: "Preview shared review",
        visibilityListHeader: "This is the view that will be shared with {{name}}. This includes:",
        types: {
            manager: "Manager answers they have access to",
            self: "Self-review answers",
            peerAnonymous: "Peer answers they have access to (anonymized)",
            peerWithNames: "Peer answers they have access to (with names visible)",
            upwardAnonymous: "Upward review answers they have access to (anonymized)",
            upwardWithNames: "Upward review answers they have access to (with names visible)"
        },
        editsVisible: "Any edits made after sharing will also be visible.",
        acknowledgmentWarning: "This cycle requires acknowledgment, so you won't be able to unshare once shared.",
        cancel: "Cancel",
        share: "Share"
    },
    ReviewDetailActions: {
        actions: "Review actions",
        preparing: "Preparing…",
        manage: "Manage review"
    },
    ReviewExportAction: {
        exportPdf: "Export PDF",
        preparing: "Preparing…",
        fullVersion: "Full version",
        fullVersionDescription: "Every question and answer on this review.",
        revieweeVersion: "Reviewee version",
        revieweeVersionDescription: "Only what the reviewee can see. Questions hidden from them are left out.",
        successToast: "PDF file was exported",
        errorToast: "The export failed. Please try again."
    },
    ReviewReleaseActions: {
        previewAndShare: "Preview and share",
        editReview: "Edit review",
        reviewType: {
            manager: "Manager review",
            self: "Self review",
            peer: "Peer review",
            upward: "Upward review"
        },
        shareDisabledReason: "This review can't be shared because all questions are hidden from the reviewee.",
        unshare: "Unshare",
        acknowledge: "Acknowledge",
        cancel: "Cancel",
        unshareDialog: {
            title: "Unshare this review?",
            description: "{{name}} will lose access to any manager and peer feedback for this review until it's shared again.",
            confirm: "Unshare review"
        },
        acknowledgeDialog: {
            title: "Acknowledge this review?",
            description: "Acknowledging confirms that you've read this review. Your name and the date will be recorded on the review as proof of receipt.",
            confirmation: "I confirm I've read this review",
            confirm: "Acknowledge"
        },
        shareSuccessToast: "You shared this review",
        unshareSuccessToast: "You unshared this review",
        acknowledgeSuccessToast: "You acknowledged this review",
        reviewChangedToast: "This review changed since you opened it. We refreshed it — please review the latest version and acknowledge again.",
        errorToast: "Sorry, something went wrong. Please try again."
    },
    ParticipantCard: {
        kind: {
            reviewee: "Reviewee",
            manager: "Manager",
            peer: "Peer",
            upward: "Upward"
        },
        anonymousName: {
            peer: "Anonymous peer",
            upward: "Anonymous upward reviewer"
        },
        managerRole: {
            direct: "Direct Manager",
            temporary: "temporary Direct Manager",
            previous: "previous Direct Manager"
        },
        status: {
            notStarted: "Not started",
            inProgress: "In progress",
            submitted: "Submitted"
        },
        submittedOn: "on {{date}}",
        dueOn: "Due {{date}}",
        deletedMember: "Deleted member",
        noDirectManager: "No Direct Manager"
    },
    ReviewQuestionCard: {
        badges: {
            noAnswer: "No answer",
            optional: "Optional"
        },
        emptyAnswer: {
            text: "No answer yet.",
            rating: "Not rated yet.",
            choice: "No selection yet."
        },
        reviewerKind: {
            manager: "Manager review",
            self: "Self-review",
            peer: "Peer review",
            upward: "Upward review"
        },
        anonymousReviewer: "Anonymous reviewer",
        deletedMember: "Deleted member",
        ratingUnlabeledValue: "Level {{value}}",
        offScaleAnswers: "Answers outside the current scale",
        selectedBy: "Selected by {{names}}"
    },
    ReviewSummary: {
        eyebrow: "AI summary",
        disclaimer: "This summary was generated by AI and may contain inaccuracies. Review it alongside the full responses below.",
        errorToast: "Something went wrong. Please try again.",
        callout: {
            heading: "Need a quick overview?",
            body: "Generate an AI summary to see the main themes from all submitted reviews in one place.",
            generate: "Generate summary",
            generating: "Generating summary…",
            noTextQuestions: "A summary can't be generated because this review cycle has no text-based questions."
        },
        menu: {
            triggerAriaLabel: "Summary actions",
            regenerate: "Regenerate",
            dismiss: "Dismiss"
        },
        liveRegion: {
            loading: "Loading review summary…"
        }
    },
    GoalDetailPage: {
        editGoal: "Edit goal",
        draft: "Draft",
        archived: "Archived",
        liveRegion: {
            loading: "Loading goal"
        },
        breadcrumb: {
            ariaLabel: "Breadcrumb",
            people: "People",
            progression: "Progression",
            goals: "Goals"
        },
        type: {
            organization: "Organization goal",
            team: "Team goal",
            personal: "Individual goal"
        },
        sidebar: {
            owner: "Owner",
            deletedMember: "Deleted member",
            unknownTeam: "Unknown team",
            entireOrganization: "Entire organization",
            teamKind: "Team",
            directReportsOf: "{{name}}'s direct reports",
            reportingLineOf: "{{name}}'s reporting line",
            createdBy: "Created by {{name}}",
            contributors: "Contributors ({{count}})",
            showAllContributors_one: "Show all contributors ({{count}})",
            showAllContributors_other: "Show all contributors ({{count}})",
            showLessContributors: "Show less",
            parentGoal: "Parent goal",
            startDate: "Start date",
            due: "Due",
            visibility: "Visibility"
        },
        parentScope: {
            organization: "Organization",
            team: "Team",
            personal: "Individual"
        },
        due: {
            dueIn_one: "in {{count}} day",
            dueIn_other: "in {{count}} days",
            today: "Due today",
            overdue: "Overdue"
        },
        visibility: {
            allOrganization: "Visible to the organization",
            ownerAndContributorsOnly: "Visible to the owner, contributors and their higher-ups"
        },
        description: {
            heading: "Description"
        },
        progress: {
            heading: "Progress",
            percent: "{{value}}%",
            ariaLabel: "{{title}} progress"
        },
        status: {
            onTrack: "On track",
            atRisk: "At risk",
            offTrack: "Off track",
            noStatus: "No status"
        },
        trackingMethod: {
            simple: "Simple progress — a single percentage, updated manually",
            measurements: "Metrics — weighted average of the measurements below",
            subGoals: "Sub-goals — updated manually, based on the sub-goals below",
            subGoalsAutomatic: "Auto-update from sub-goals — recalculated whenever a sub-goal changes"
        }
    },
    GoalMeasurementRow: {
        valuePair: "{{current}} → {{target}}",
        boolean: {
            completed: "Completed",
            incomplete: "Incomplete"
        },
        progressAriaLabel: "{{title}} progress",
        progressPercent: "{{value}}%"
    },
    GoalUpdates: {
        heading: "Updates",
        noUpdates: "No updates posted yet.",
        showAll_one: "Show all updates ({{count}})",
        showAll_other: "Show all updates ({{count}})",
        showLess: "Show less"
    },
    GoalUpdateCard: {
        relativeTime: {
            today: "today",
            days_one: "{{count}} day ago",
            days_other: "{{count}} days ago"
        },
        overallProgress: "Overall progress",
        progressTransition: "{{previous}}% → {{current}}%",
        progressDelta: "({{delta}}%)",
        progressValue: "{{value}}%",
        measurementTransition: "{{previous}} → {{current}}",
        status: {
            onTrack: "On track",
            atRisk: "At risk",
            offTrack: "Off track",
            noStatus: "No status"
        }
    },
    GoalProgressUpdate: {
        addUpdate: "Update progress",
        actions: {
            ariaLabel: "Actions for {{author}}'s update",
            automaticAuthor: "this automatic",
            edit: "Edit",
            delete: "Delete"
        },
        status: {
            onTrack: "On track",
            atRisk: "At risk",
            offTrack: "Off track",
            noStatus: "No status"
        },
        addedToast: "Progress update added",
        addErrorToast: "Error adding progress update",
        editedToast: "Progress updated successfully",
        editErrorToast: "Error updating progress",
        deletedToast: "Progress update deleted",
        deleteErrorToast: "Sorry, something went wrong. Please try again.",
        dialog: {
            addTitle: "Update progress",
            editTitle: "Edit progress",
            statusLabel: "Status",
            progressLabel: "Goal progress",
            progressPercent: "{{value}}%",
            progressInvalid: "Enter a number between 0 and 100.",
            progressFromMeasurements: "Calculated from the measurements above. Type over it to set it yourself.",
            progressFromSubgoals: "Auto-update from sub-goals is enabled. Progress cannot be manually updated.",
            loadingAriaLabel: "Loading the goal",
            measurementsLabel: "Measurements",
            measurementTarget: "Target: {{target}}",
            measurementInvalid: "Enter a number.",
            commentLabel: "Comment",
            commentPlaceholder: "Add a comment about this progress update...",
            cancel: "Cancel",
            addSubmit: "Save progress",
            editSubmit: "Save changes"
        },
        delete: {
            title: "Delete progress update?",
            body: "This progress update will be deleted. This action cannot be undone.",
            confirm: "Delete",
            cancel: "Cancel"
        },
        discard: {
            title: "Discard this update?",
            body: "You have not saved this yet. Leaving now will lose what you have written.",
            confirm: "Discard",
            cancel: "Keep editing"
        }
    },
    GoalSubgoals: {
        deletedMember: "Deleted member",
        heading_one: "Subgoals ({{count}})",
        heading_other: "Subgoals ({{count}})",
        type: {
            personal: "Individual goal",
            team: "Team goal",
            organization: "Organization goal"
        },
        status: {
            onTrack: "On track",
            atRisk: "At risk",
            offTrack: "Off track",
            noStatus: "No status"
        },
        progressAriaLabel: "{{title}} progress",
        progressPercent: "{{value}}%",
        dueLabel: "Due {{date}}",
        latestUpdate: {
            heading: "Latest update",
            noUpdates: "No updates posted yet.",
            today: "today",
            days_one: "{{count}} day ago",
            days_other: "{{count}} days ago",
            weeks_one: "{{count}} week ago",
            weeks_other: "{{count}} weeks ago"
        }
    },
    GoalNotFound: {
        heading: "Goal not found",
        body: "This goal doesn't exist or you don't have access to it.",
        backToDirectory: "Back to people"
    },
    ProfileFeedbackPage: {
        liveRegion: {
            loading: "Loading feedback",
            loadingMoreAnnouncement: "Loading more feedback",
            loadedMore_one: "Loaded {{count}} more feedback",
            loadedMore_other: "Loaded {{count}} more feedback"
        },
        error: "We couldn't load your feedback right now.",
        accessDenied: "You don't have access to this feedback.",
        ariaLabel: "Your feedback",
        loadingMore: "Loading more",
        unread: "Unread",
        empty: {
            headline: "You haven't sent any feedback yet.",
            subtext: "Feedback you send to your manager — through surveys or directly — will show up here."
        },
        unrepliedEmpty: {
            headline: "Nothing waiting on a reply.",
            subtext: "Every message you've sent has been answered."
        },
        status: {
            awaiting: "Awaiting reply"
        }
    },
    FeedbackToolbar: {
        filters: {
            ariaLabel: "Filter feedback",
            clearAriaLabel: "Clear feedback filter",
            all: "All feedback",
            unreplied: "Awaiting reply"
        },
        leaveSuggestion: "Leave a suggestion"
    },
    FeedbackThreadDetail: {
        liveRegion: {
            loading: "Loading conversation"
        },
        error: "We couldn't load this conversation right now.",
        questionSenderLabel: "Workleap",
        status: {
            awaiting: "Awaiting reply"
        },
        details: {
            header: "Details",
            sentiment: "Sentiment",
            metric: "Metric",
            feedbackType: "Feedback type",
            collapse: "Collapse details",
            expand: "Show details"
        },
        emptyReadingPane: "Select a message on the left to read it and reply. Authors stay anonymous unless they choose to sign their message."
    },
    ProfileFeedbackReplyComposer: {
        textareaLabel: "Reply",
        placeholder: "Reply…",
        send: "Send reply",
        sending: "Sending reply…",
        successToast: "Reply sent",
        errorToast: "Couldn't send your reply. Please try again.",
        replyAnonymously: "Reply anonymously",
        revealIdentityErrorToast: "Unable to update anonymity for this conversation. Please try again."
    },
    ProfileContactCard: {
        title: "Contact"
    },
    ProfileAboutAiCard: {
        emptyRecentWork: "No recent work found.",
        emptyWorkingToward: "No goals found.",
        emptyRecognizedFor: "No recognition found.",
        emptyCollaborators: "No frequent collaborators found.",
        agent: "Agent",
        lastUpdated: "Updated {{timeAgo}}",
        refresh: "Regenerate now",
        refreshing: "Refreshing profile…",
        loadingLiveRegion: "Generating a profile…",
        stepWriting: "Writing it up…",
        stepLookingUp: "Looking up {{name}}…",
        stepGoals: "Reading goals…",
        stepRecognition: "Searching recognition and engagement…",
        stepActivity: "Scanning recent work…",
        error: "This couldn't be put together right now.",
        retry: "Try again",
        sectionRecentWork: "Recent work",
        sectionCollaborators: "Works with",
        sectionWorkingToward: "Working toward",
        sectionRecognizedFor: "Recognized for",
        collaborationCommunication: "Communication",
        collaborationWork: "Work",
        collaborationEngagement: "Engagement",
        collaborationCommunicationTooltip: "They talk regularly through messages, email, or meetings.",
        collaborationWorkTooltip: "They work on the same projects or documents.",
        collaborationEngagementTooltip: "Connected through goals and recognition.",
        collaboratorsShowMore: "Show {{count}} more",
        collaboratorsShowLess: "Show fewer",
        connectCta: "Connect more tools to get richer profile insights"
    },
    ProfileAboutCard: {
        title: "About",
        tenureNew: "New here",
        tenureMonths: "{{count}} month here",
        tenureMonths_other: "{{count}} months here",
        tenureYears: "{{count}} year here",
        tenureYears_other: "{{count}} years here",
        interestsLabel: "Interests",
        addBioPrompt: "Tell your teammates a little about yourself.",
        addBioCta: "Add a bio"
    },
    ProfileCompetenciesCard: {
        title: "Competencies"
    },
    ProfileGoodVibesStats: {
        receivedLabel: "Good vibes received",
        givenLabel: "Good vibes given",
        deltaVsPriorPeriod: "{{delta}} vs prior period",
        liveRegion: {
            loading: "Loading good vibes statistics…"
        }
    },
    ProfileDirectReportsCard: {
        title: "Direct reports"
    },
    ProfileInCommonCard: {
        title: "In common with you",
        sameManager: "Same manager: {{name}}"
    },
    ProfileNotFound: {
        heading: "Profile not found",
        body: "We couldn't find that profile. It may have been moved or removed.",
        backToDirectory: "Back to directory"
    },
    ProfileTimelinePage: {
        ariaLabel: "Timeline events",
        error: "We couldn't load the timeline right now.",
        liveRegion: {
            loading: "Loading timeline"
        },
        empty: {
            headline: "No timeline activity for {{firstName}} yet.",
            subtext: "Feedback, recognition, and milestones appear here as they happen.",
            fallbackName: "this person"
        },
        textValue: {
            feedback: "Feedback",
            goodVibes: "Good Vibes",
            started: "Milestone",
            promotion: "Milestone",
            anniversary: "Milestone"
        }
    },
    TimelineEntryDetailRoute: {
        titleLeafByType: {
            feedback: "Feedback",
            goodVibes: "Good Vibes",
            started: "Milestone",
            promotion: "Milestone",
            anniversary: "Milestone"
        }
    },
    TimelineFilterBar: {
        typeFilter: {
            ariaLabel: "Filter by type",
            clearAriaLabel: "Clear type filter",
            options: {
                all: "All types",
                milestones: "Milestones",
                goodVibes: "Good Vibes",
                feedback: "Feedback"
            }
        },
        timeFilter: {
            ariaLabel: "Filter by time",
            clearAriaLabel: "Clear time filter",
            options: {
                allTime: "All time",
                last90Days: "Last 90 days",
                thisYear: "This year"
            }
        },
        resetFilters: "Reset filters",
        eventCount_one: "{{count}} event",
        eventCount_other: "{{count}} events"
    },
    TimelineFeedbackCard: {
        from: "From {{name}}",
        deletedMember: "Deleted member",
        openDetailAriaLabel: "Open feedback detail, {{date}}"
    },
    TimelineSentimentTag: {
        positive: "Positive",
        constructive: "Constructive",
        neutral: "Neutral"
    },
    TimelineGoodVibesCard: {
        eyebrow: "Good Vibes",
        unknownSender: "Deleted member",
        openDetailAriaLabel: "Open Good Vibes from {{sender}}, {{date}}",
        from: "From {{name}}",
        reactionTotal_one: "{{count}} reaction",
        reactionTotal_other: "{{count}} reactions"
    },
    TimelineStartedCard: {
        eyebrow: "Started",
        narrative: "Joined {{orgName}}.",
        narrativeWithTitle: "Joined {{orgName}} as <strong>{{jobTitle}}</strong>.",
        openDetailAriaLabel: "Open started milestone detail, {{date}}"
    },
    TimelinePromotionCard: {
        eyebrow: "Job change",
        narrative: "<lead>Title changed to </lead><strong>{{jobTitle}}</strong><tail> from {{previousJobTitle}}.</tail>",
        openDetailAriaLabel: "Open job change milestone detail, {{date}}"
    },
    TimelineAnniversaryCard: {
        eyebrow: "Anniversary",
        narrative_one: "{{firstName}} has been at {{orgName}} for <strong>{{count}} year</strong>.",
        narrative_other: "{{firstName}} has been at {{orgName}} for <strong>{{count}} years</strong>.",
        openDetailAriaLabel: "Open anniversary milestone detail, {{date}}"
    },
    GoodVibesDetailDialog: { ...goodVibeDetailDialogEn },
    FeedbackDetailDialog: {
        heading: "Feedback from {{sender}}",
        unknownSender: "Someone",
        deletedMember: "Deleted member",
        from: "From {{name}}"
    },
    MilestoneDetailDialog: {
        heading: "Milestone detail",
        started: {
            eyebrow: "Started",
            narrative: "Joined {{orgName}}.",
            narrativeWithTitle: "Joined {{orgName}} as <strong>{{jobTitle}}</strong>."
        },
        promotion: {
            eyebrow: "Job change",
            narrative: "<lead>Title changed to </lead><strong>{{jobTitle}}</strong><tail> from {{previousJobTitle}}.</tail>"
        },
        anniversary: {
            eyebrow: "Anniversary",
            narrative_one: "{{firstName}} has been at {{orgName}} for <strong>{{count}} year</strong>.",
            narrative_other: "{{firstName}} has been at {{orgName}} for <strong>{{count}} years</strong>."
        }
    },
    ProfileGoodVibesPage: {
        error: "We couldn't load good vibes right now.",
        empty: "No recognition matches these filters.",
        resetFilters: "Reset filters",
        sendInClassic: "Send Good Vibes",
        sendGoodVibes: "Send Good Vibes",
        giveModal: {
            eyebrow: "Heads up",
            title: "One quick detour",
            body: "This feature isn't available in the new app yet. We'll take you to Officevibe to complete it. Nothing will be lost.",
            cancel: "Cancel",
            continue: "Continue in Officevibe"
        },
        composeDialog: {
            title: "Send Good Vibes",
            recipientsLabel: "To",
            recipientsPlaceholder: "Add another",
            recipientsSearchPlaceholder: "Search people",
            recipientsSelectedLabel: "Selected recipients",
            recipientsEmpty: "No results",
            recipientsLoading: "Searching…",
            subjectLabel: "Subject",
            subjectPlaceholder: "What did they do?",
            writeOwnLabel: "Write your own, or pick a prompt",
            useTypedLabel: 'Use "{{text}}"',
            customCategoryLabel: "Custom",
            changeSubjectLabel: "Change",
            recipientsRemoveLabel: "Remove {{name}}",
            messageLabel: "Message",
            messagePlaceholder: "Say what they did and why it mattered.",
            messageCharactersLeft: "{{count}} characters left",
            audienceLabel: "Audience",
            directLabel: "Direct",
            directDescription: "Only the recipients, their managers, and higher-ups can see this.",
            publicLabel: "Public",
            publicDescription: "Everyone at the company can see this.",
            fromLabel: "From {{name}}",
            cancelLabel: "Cancel",
            submitDirectLabel: "Send directly",
            submitPublicLabel: "Send publicly",
            discardChangesTitle: "Discard this Good Vibe?",
            discardChangesBody: "You have not sent this yet. Leaving now will lose what you have written.",
            discardChangesConfirmLabel: "Discard",
            discardChangesCancelLabel: "Keep editing",
            successMessage: "You just made someone's day!",
            successCloseLabel: "Close",
            mostUsedThisMonthLabel: "Most used this month",
            usageCountLabel: "{{count}} uses this month"
        },
        giveError: "Couldn't send. Please try again.",
        visibility: {
            public: "Public",
            direct: "Direct"
        },
        sealed: {
            ariaLabel: "New Good Vibes for {{recipients}}. Press and hold to open.",
            badge: "New Good Vibes",
            pressAndHold: "Press and hold to open"
        },
        emptyTimeframe: {
            "7d": "No good vibes in the last 7 days.",
            "30d": "No good vibes in the last 30 days.",
            "3m": "No good vibes in the last 3 months.",
            "6m": "No good vibes in the last 6 months.",
            quarter: "No good vibes this quarter.",
            year: "No good vibes this year."
        },
        emptyAllTime: "No good vibes yet.",
        listAriaLabel: "Good vibes",
        liveRegion: {
            loading: "Loading good vibes…",
            loadingMore: "Loading more good vibes…",
            loadedMore_one: "Loaded {{count}} more good vibe",
            loadedMore_other: "Loaded {{count}} more good vibes"
        },
        filters: {
            audience: {
                label: "Audience",
                triggerPrefix: "Audience:",
                clearAriaLabel: "Clear audience filter",
                options: {
                    all: "All",
                    public: "Public",
                    direct: "Direct"
                }
            },
            direction: {
                groupLabel: "Direction",
                triggerPrefix: "Direction:",
                clearAriaLabel: "Clear direction filter",
                options: {
                    all: "All",
                    received: "Received",
                    given: "Sent"
                }
            },
            themes: {
                label: "Themes",
                ariaLabel: "Filter by theme",
                clearFilter: "Clear filter"
            },
            timeframe: {
                ariaLabel: "Filter by time frame",
                clearAriaLabel: "Clear time frame filter",
                options: {
                    "7d": "Last 7 days",
                    "30d": "Last 30 days",
                    "3m": "Last 3 months",
                    "6m": "Last 6 months",
                    quarter: "This quarter",
                    year: "This year",
                    all: "All time"
                }
            }
        }
    },
    GoodVibeCard: { ...goodVibeCardEn },
    ProfileEngagementPage: {
        liveRegion: {
            loading: "Loading engagement"
        }
    },
    ProfileEngagementMetricsPage: {
        breadcrumb: {
            ariaLabel: "Metrics",
            here: "Metrics"
        },
        pageTitle: "Your engagement",
        pageDescription: "View your engagement score and your results by metric. Your responses are anonymous and only you have access to them.",
        privacyLabel: "Who can see this",
        privacyTooltip: "Only you can see your engagement scores.",
        metricTooltipLabel: "About {{metric}}",
        metricTooltips: {},
        subMetrics: {
            eyebrow: "Sub-metrics",
            helper: "Select one to see its own trend.",
            empty: "No sub-metric details yet."
        },
        chart: {
            title: "Your {{metric}} vs {{company}}",
            titleWithSub: "Your {{sub}} vs {{company}}",
            ariaLabel: "{{subject}} score over the last 3 months",
            legendYou: "You",
            legendCompany: "Company",
            scoreOutOf: "/ 10",
            changePeriod: "in the last 3 months",
            changeNone: "No change in the last 3 months",
            changeUnavailable: "No comparison available",
            subMetricEmpty: "No trend data yet for this sub-measure.",
            subMetricNoHistory: "No history yet for {{sub}} — showing {{metric}} for reference."
        },
        error: {
            title: "We couldn't load your engagement metrics right now."
        },
        empty: {
            description: "Your engagement scores will appear here once you've answered a few surveys."
        },
        liveRegion: {
            loading: "Loading your engagement metrics"
        }
    },
    ProfileGoodVibesPanel: {
        title: "Your Good Vibes",
        sendGoodVibes: "Send Good Vibes",
        sendInClassic: "Send Good Vibes",
        toggle: {
            ariaLabel: "Good Vibes direction",
            received: "Received",
            sent: "Sent"
        },
        emptyReceived: "No Good Vibes yet — recognition you receive will show up here.",
        emptySent: "You haven't sent any Good Vibes yet.",
        error: "We couldn't load good vibes right now.",
        listAriaLabel: "Good vibes",
        giveError: "Couldn't send. Please try again.",
        visibility: {
            public: "Public",
            direct: "Direct"
        },
        sealed: {
            ariaLabel: "New Good Vibes for {{recipients}}. Press and hold to open.",
            badge: "New Good Vibes",
            pressAndHold: "Press and hold to open"
        },
        liveRegion: {
            loading: "Loading good vibes…",
            loadingMore: "Loading more good vibes…",
            loadedMore_one: "Loaded {{count}} more good vibe",
            loadedMore_other: "Loaded {{count}} more good vibes"
        },
        composeDialog: {
            title: "Send Good Vibes",
            recipientsLabel: "To",
            recipientsPlaceholder: "Add another",
            recipientsSearchPlaceholder: "Search people",
            recipientsSelectedLabel: "Selected recipients",
            recipientsEmpty: "No results",
            recipientsLoading: "Searching…",
            subjectLabel: "Subject",
            subjectPlaceholder: "What did they do?",
            writeOwnLabel: "Write your own, or pick a prompt",
            useTypedLabel: 'Use "{{text}}"',
            customCategoryLabel: "Custom",
            changeSubjectLabel: "Change",
            recipientsRemoveLabel: "Remove {{name}}",
            messageLabel: "Message",
            messagePlaceholder: "Say what they did and why it mattered.",
            messageCharactersLeft: "{{count}} characters left",
            audienceLabel: "Audience",
            directLabel: "Direct",
            directDescription: "Only the recipients, their managers, and higher-ups can see this.",
            publicLabel: "Public",
            publicDescription: "Everyone at the company can see this.",
            fromLabel: "From {{name}}",
            cancelLabel: "Cancel",
            submitDirectLabel: "Send directly",
            submitPublicLabel: "Send publicly",
            discardChangesTitle: "Discard this Good Vibe?",
            discardChangesBody: "You have not sent this yet. Leaving now will lose what you have written.",
            discardChangesConfirmLabel: "Discard",
            discardChangesCancelLabel: "Keep editing",
            successMessage: "You just made someone's day!",
            successCloseLabel: "Close",
            mostUsedThisMonthLabel: "Most used this month",
            usageCountLabel: "{{count}} uses this month"
        },
        giveModal: {
            eyebrow: "Heads up",
            title: "One quick detour",
            body: "This feature isn't available in the new app yet. We'll take you to Officevibe to complete it. Nothing will be lost.",
            cancel: "Cancel",
            continue: "Continue in Officevibe"
        }
    },
    ProfileProgressionPage: {
        latestReview: {
            title: "Latest review",
            viewAll: "View all reviews",
            ratingAriaLabel: "Rating {{score}} out of {{scale}}",
            deliveryBadge: {
                shared: "Shared",
                acknowledged: "Acknowledged"
            },
            attribution: {
                shared: "{{date}}",
                acknowledged: "{{date}}"
            },
            openAriaLabel: "Open review: {{cycleTitle}}",
            empty: "No reviews shared with you yet.",
            error: "We couldn't load your latest review right now.",
            liveRegion: {
                loading: "Loading your latest review"
            }
        },
        experience: {
            title: "Experience",
            viewTimeline: "View timeline",
            sinceDate: "since {{date}}",
            dateRange: "{{start}} – {{end}}",
            promotionWithDate: "Promotion · {{date}}",
            anniversary_one: "Celebrating {{count}} year at {{orgName}}",
            anniversary_other: "Celebrating {{count}} years at {{orgName}}",
            empty: "No experience to show yet.",
            error: "We couldn't load your experience right now.",
            liveRegion: {
                loading: "Loading your experience"
            }
        },
        goals: {
            title: "Goals",
            viewAll: "View all my goals",
            statusAndProgress: "{{status}} · {{progress}}%",
            status: {
                onTrack: "On track",
                atRisk: "At risk",
                offTrack: "Off track",
                noStatus: "No status"
            },
            untitled: "Untitled goal",
            draft: "Draft",
            finish: "Finish",
            empty: "No goals yet.",
            error: "We couldn't load your goals right now.",
            liveRegion: {
                loading: "Loading your top goals"
            }
        },
        competencies: {
            title: "Competencies",
            empty: "No competencies added yet.",
            editAction: "Edit competencies",
            error: "We couldn't load competencies right now."
        },
        liveRegion: {
            loading: "Loading progression"
        }
    },
    EngagementScoresPanel: {
        title: "Your engagement",
        privacyLabel: "Who can see this",
        privacyTooltip: "Only you can see your engagement scores.",
        takeSurvey: "Take survey",
        opensInNewTab: "opens in new tab",
        scoreAriaLabel: "Engagement score {{score}} out of {{max}}, {{band}}",
        bandAriaLabel: "Score band: {{band}}",
        changeValue: "{{value}} pts in the last 3 months",
        changeNone: "No change in the last 3 months",
        directionUp: "Up",
        directionDown: "Down",
        directionNone: "No change",
        delta: "{{value}} pts",
        deltaUnavailable: "No comparison available",
        legendYou: "You",
        legendCompany: "Company",
        chartAriaLabel: "Your engagement score over the last 3 months, compared with the company average.",
        chartAriaLabelSolo: "Your engagement score over the last 3 months.",
        topGains: "Top gains",
        topDecreases: "Top decreases",
        showAllMetrics: "Show all metrics",
        hideAllMetrics: "Hide all metrics",
        allMetricsAriaLabel: "All engagement metrics",
        openMetricDetailAriaLabel: "Open {{label}} details",
        empty: "Your engagement scores will appear here once you've answered a few surveys.",
        error: "We couldn't load your engagement scores right now.",
        loadingAnnouncement: "Loading your engagement scores"
    },
    EngagementFeedbackPanel: {
        title: "Your feedback",
        viewAll: "View all",
        sendFeedback: "Send feedback",
        empty: "No feedback yet.",
        error: "We couldn't load your feedback.",
        sender: {
            you: "You",
            anonymousYou: "Anonymous (you)"
        },
        status: {
            awaiting: "Awaiting reply",
            replied: "Replied"
        },
        date: {
            week: "Week of {{date}}",
            absolute: "{{date}}"
        },
        openRow: "Open feedback from {{sender}}, {{status}}. {{snippet}}",
        openRowUnread: "Open feedback from {{sender}}, {{status}}, new reply. {{snippet}}",
        liveRegion: {
            loading: "Loading your feedback"
        }
    },
    EngagementFeedbackThreadDialog: {
        title: "Feedback",
        close: "Close"
    },
    EngagementRating: {
        critical: "Critical",
        veryLow: "Very low",
        low: "Low",
        good: "Good",
        veryGood: "Very good",
        great: "Great",
        amazing: "Amazing"
    }
};
